export const buildInfo = {
  branch: 'release/1.22.3',
  commit: '47fc74b',
  buildDate: '2026-10-26T13:55:00.165Z',
};
